export default __webpack_public_path__ + "static/media/B2_21.ac7af4b2.mp3";